export default {
  default: () => import("/builds/rotesteam/keycloak-group-manager/layouts/default.vue").then(m => m.default || m)
}